import React from 'react';
import DatePicker from 'react-datepicker';


class DateInput extends React.Component{

    render(){
      return(
        <div className="form-group">
          <label className="form-control-label">{ this.props.input_label }</label>
          <DatePicker 
            className="form-control"
            selected={this.props.input_value}
            onChange={this.props.input_onChange}
            placeholderText={this.props.input_placeholder}
            dateFormat={this.props.input_format}
          />
        </div>
      );
    }
} 

export {DateInput};


// WEBPACK FOOTER //
// ./src/components/DateInput.js